import script from "./bbs.vue?vue&type=script&lang=ts&setup=true"
export * from "./bbs.vue?vue&type=script&lang=ts&setup=true"

import "./bbs.vue?vue&type=style&index=0&id=f856af4a&lang=less&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/ALLIANCE_FRONTEND1/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f856af4a"]])

export default __exports__